import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { JobService } from '../../services/job.service';
import { SubsidiaryService } from '../../services/subsidiary.service';

@Component({
    selector: 'app-update-job',
    templateUrl: './update-job.component.html',
    styleUrls: ['./update-job.component.css', '../../app.component.css']
})

export class UpdateJobComponent implements OnInit, OnDestroy {

    jobForm: FormGroup;
    job: any = [];

    subsidiaries = {};
    subsidiaryInit: any;
    subsidiaryText = '';

    id: string;

    gjSubs: any;
    gsSubs: any;
    gssSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private jobService: JobService,
                private subsidiaryService: SubsidiaryService) {
        this.loadSubsidiaries();

        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.gjSubs = this.jobService.getJob(this.id).subscribe(jobObj => {
                this.gjSubs.unsubscribe();

                this.job = jobObj;

                this.gsSubs = this.subsidiaryService.getSubsidiary(this.job.subsidiaryId).subscribe(subsidiaryObj => {
                    this.gsSubs.unsubscribe();

                    this.subsidiaryText = subsidiaryObj.name;
                });
            });

            
        });
    }

    ngOnInit() {
        this.jobForm = this.formBuilder.group({
            name: ['', Validators.required],
            description: ['', Validators.required],
            internalNumber: ['', Validators.required],
            baseSalary: ['', Validators.required],
            extraSalary: [0, Validators.required],
            subsidiary: ['', Validators.required]
        });
    }

    onSubmitJob() {
        this.job = this.saveJob();

        this.jobService.putJob(this.job, this.id).then(res => {
            this.router.navigate(['/roles_jobs', {outlets: {'tab_job': ['jobs']}}]);
        });
    }

    saveJob() {
        const jobJson = {
            baseSalary: this.jobForm.get('baseSalary').value,
            extraSalary: this.jobForm.get('extraSalary').value,
            description: this.jobForm.get('description').value,
            internalNumber: this.jobForm.get('internalNumber').value,
            name: this.jobForm.get('name').value,
            subsidiaryId: this.subsidiaries[this.jobForm.get('subsidiary').value],
            updatedAt: new Date()
        };

        return jobJson;
    }

    loadSubsidiaries() {
        this.gssSubs = this.subsidiaryService.getSubsidiaries().subscribe(tempSubsidiaries => {
            const data = {};

            for (const idx in tempSubsidiaries) {
                data[tempSubsidiaries[idx].name] = null;

                this.subsidiaries[tempSubsidiaries[idx].name] = tempSubsidiaries[idx].id$;
            }

            this.subsidiaryInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.subsidiaries[val]);
                }
            };
        });
    }

    onBlurSubsidiary() {
        if (this.subsidiaries[this.subsidiaryText] === undefined) {
            this.subsidiaryText = '';
        }
    }

    ngOnDestroy() {
        this.gssSubs.unsubscribe();
    }

}
